<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item :label="$t('views.goodsSpecSame.form.goodSpec')" prop="goodSpecId" >
        <a-select
          v-model="form.goodSpecId"
          show-search
          allow-clear
          option-filter-prop="_label"
          option-label-prop="_label"
          :loading="goodSpecLoading"
          :placeholder="$t('views.goodsSpecSame.form.goodSpecPlaceholder')"
          :filter-option="filterGoodSpecOption"
          :getPopupContainer="trigger => trigger.parentNode"
          @change="onGoodSpecIdChange"
        >
          <a-select-option
            v-for="it in goodSpecOptions"
            :key="String(it.id)"
            :value="String(it.id)"
            :_label="it._label"
          >
            {{ it._label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.goodsSpecSame.form.selectedOption')" prop="specCombinationId" >
        <a-select
          v-model="form.specCombinationId"
          show-search
          allow-clear
          option-filter-prop="_label"
          option-label-prop="_label"
          :loading="specCombinationLoading"
          :disabled="specCombinationSelectDisabled"
          :placeholder="specCombinationPlaceholder"
          :filter-option="filterSpecCombinationOption"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <a-select-option
            v-for="it in specCombinationOptions"
            :key="String(it.id)"
            :value="String(it.id)"
            :_label="it._label"
          >
            {{ it._label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('views.goodsSpecSame.form.combinationOptions')" prop="specCombinationList" >
        <a-select
          v-model="specCombinationListModel"
          mode="multiple"
          show-search
          allow-clear
          option-filter-prop="_label"
          option-label-prop="_label"
          :loading="specCombinationLoading"
          :disabled="specCombinationSelectDisabled"
          :placeholder="combinationListPlaceholder"
          :filter-option="filterSpecCombinationOption"
          :getPopupContainer="trigger => trigger.parentNode"
        >
          <a-select-option
            v-for="it in specCombinationOptions"
            :key="String(it.id)"
            :value="String(it.id)"
            :_label="it._label"
          >
            {{ it._label }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('views.goodsSpecSame.form.save') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('views.goodsSpecSame.form.cancel') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getGoodsSpecSame, addGoodsSpecSame, updateGoodsSpecSame } from '@/api/user/goodsSpecSame'
import { listGoodsSpecCombinationOptions } from '@/api/user/goodsCombination'
import { listGoodsSpecGoodSpecOptions } from '@/api/user/goodsSpec'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      specCombinationLoading: false,
      specCombinationOptions: [],
      goodSpecLoading: false,
      goodSpecOptions: [],
      form: {
        id: null,
        goodId: null,
        goodSpecId: null,
        specCombinationId: null,
        specCombinationList: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      },
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  computed: {
    formTitle () {
      return this.formType === 2
        ? this.$t('views.goodsSpecSame.title.edit')
        : this.$t('views.goodsSpecSame.title.add')
    },
    specCombinationSelectDisabled () {
      const g = this.form && this.form.goodSpecId
      return g === null || g === undefined || String(g).trim() === ''
    },
    specCombinationPlaceholder () {
      return this.specCombinationSelectDisabled
        ? this.$t('views.goodsSpecSame.form.specCombinationPlaceholderDisabled')
        : this.$t('views.goodsSpecSame.form.specCombinationPlaceholder')
    },
    combinationListPlaceholder () {
      return this.specCombinationSelectDisabled
        ? this.$t('views.goodsSpecSame.form.combinationListPlaceholderDisabled')
        : this.$t('views.goodsSpecSame.form.combinationListPlaceholder')
    },
    specCombinationListModel: {
      get () {
        const raw = this.form && this.form.specCombinationList
        if (raw === null || raw === undefined || String(raw).trim() === '') {
          return []
        }
        return String(raw)
          .split(',')
          .map(s => s.trim())
          .filter(Boolean)
      },
      set (val) {
        const arr = Array.isArray(val) ? val : []
        const ids = arr
          .map(v => (v === null || v === undefined) ? '' : String(v).trim())
          .filter(Boolean)
        this.form.specCombinationList = ids.length ? ids.join(',') : null
      }
    }
  },
  methods: {
    filterGoodSpecOption (input, option) {
      const props = option && option.componentOptions && option.componentOptions.propsData
      const label = (props && props._label) ? String(props._label) : ''
      const text = option && option.componentOptions && option.componentOptions.children && option.componentOptions.children[0] && option.componentOptions.children[0].text
      const hay = (label || text || '').toString()
      return hay.toLowerCase().includes((input || '').toLowerCase())
    },
    loadGoodSpecOptions () {
      if (this.goodSpecLoading) return
      this.goodSpecLoading = true
      const goodId = this.form && this.form.goodId ? this.form.goodId : null
      listGoodsSpecGoodSpecOptions({ goodId }).then(res => {
        const list = (res && res.data) || []
        this.goodSpecOptions = (Array.isArray(list) ? list : []).map(c => {
          const name = (c && c.specName) ? String(c.specName) : ''
          const idStr = c && c.id != null ? String(c.id) : ''
          const _label = name
            ? this.$t('views.goodsSpecSame.option.goodSpecRow', { name, id: idStr })
            : this.$t('views.goodsSpecSame.option.goodSpecRowId', { id: idStr })
          return {
            ...c,
            _label
          }
        })
      }).finally(() => {
        this.goodSpecLoading = false
      })
    },
    filterSpecCombinationOption (input, option) {
      const props = option && option.componentOptions && option.componentOptions.propsData
      const label = (props && props._label) ? String(props._label) : ''
      const text = option && option.componentOptions && option.componentOptions.children && option.componentOptions.children[0] && option.componentOptions.children[0].text
      const hay = (label || text || '').toString()
      return hay.toLowerCase().includes((input || '').toLowerCase())
    },
    loadSpecCombinationOptions () {
      if (this.specCombinationLoading) return
      const goodId = this.form && this.form.goodId ? this.form.goodId : null
      const goodSpecId = this.form && this.form.goodSpecId ? this.form.goodSpecId : null
      if (goodSpecId === null || goodSpecId === undefined || String(goodSpecId).trim() === '') {
        this.specCombinationOptions = []
        return
      }
      this.specCombinationLoading = true
      listGoodsSpecCombinationOptions({ goodId, goodSpecId }).then(res => {
        const list = (res && res.data) || []
        this.specCombinationOptions = (Array.isArray(list) ? list : []).map(c => {
          const optName = (c && c.specOptionName) ? String(c.specOptionName) : ''
          const idStr = c && c.id != null ? String(c.id) : ''
          const _label = optName
            ? this.$t('views.goodsSpecSame.option.comboRow', { name: optName, id: idStr })
            : this.$t('views.goodsSpecSame.option.comboRowId', { id: idStr })
          return {
            ...c,
            _label
          }
        })
      }).finally(() => {
        this.specCombinationLoading = false
      })
    },
    onGoodSpecIdChange () {
      this.form.specCombinationId = null
      this.form.specCombinationList = null
      this.specCombinationOptions = []
      if (!this.specCombinationSelectDisabled) {
        this.loadSpecCombinationOptions()
      }
    },
    onClose () {
      this.open = false
    },
    cancel () {
      this.open = false
      this.reset()
    },
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        goodId: null,
        goodSpecId: null,
        specCombinationId: null,
        specCombinationList: null,
        sort: null,
        status: 1,
        createTime: null,
        remark: null
      }
    },
    handleAdd (row) {
      this.reset()
      this.form.goodId = row.id
      this.loadGoodSpecOptions()
      this.formType = 1
      this.open = true
    },
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getGoodsSpecSame({ id: id }).then(response => {
        this.form = response.data
        if (this.form && this.form.specCombinationId !== null && this.form.specCombinationId !== undefined && this.form.specCombinationId !== '') {
          this.form.specCombinationId = String(this.form.specCombinationId)
        }
        if (this.form && this.form.goodSpecId !== null && this.form.goodSpecId !== undefined && this.form.goodSpecId !== '') {
          this.form.goodSpecId = String(this.form.goodSpecId)
        }
        this.loadGoodSpecOptions()
        this.$nextTick(() => {
          if (!this.specCombinationSelectDisabled) {
            this.loadSpecCombinationOptions()
          }
        })
        this.open = true
      })
    },
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateGoodsSpecSame(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.goodsSpecSame.msg.updateOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.goodsSpecSame.msg.updateFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addGoodsSpecSame(this.form).then(response => {
              if (response.success) {
                this.$message.success(this.$t('views.goodsSpecSame.msg.addOk'), 3)
                this.open = false
                this.$emit('ok')
              } else {
                const messageInfo = response.message || response.msg || this.$t('views.goodsSpecSame.msg.addFail')
                this.$message.error(messageInfo)
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
